import { Link } from '@inertiajs/react'
import { useSessionUser } from '@/store/authStore'

const MobileAuthButtons = () => {
    const { session } = useSessionUser()

    if (session.signedIn) {
        return null
    }

    return (
        <div className="lg:hidden">
            <div className="flex items-center justify-center gap-2">
                <Link
                    href="/login"
                    className="button border border-gray-300 text-gray-600 dark:text-gray-100 bg-white dark:bg-gray-700 dark:border-gray-700 transition-colors ring-primary dark:ring-white hover:border-primary dark:hover:border-white hover:ring-1 hover:text-primary dark:hover:text-white dark:hover:bg-transparent h-9 rounded-lg px-4 py-2 text-sm font-normal flex-shrink-0"
                >
                    Sign In
                </Link>
                {/* TODO: confirm canonical early-access signup route (currently /register) */}
                <Link
                    href="/register"
                    className="button bg-primary hover:bg-primary-mild text-white border border-primary dark:bg-gray-700 dark:border-gray-700 ring-primary dark:ring-white hover:border-primary dark:hover:border-white hover:ring-1 dark:hover:text-white dark:hover:bg-transparent h-9 rounded-lg px-4 py-2 text-sm font-normal flex-shrink-0"
                >
                    Start free
                </Link>
            </div>
        </div>
    )
}

export default MobileAuthButtons

